
<template>
  <div :style="{direction:$t('direction')}" class="site-wrapper hasBG">

    <Header></Header>

    <div class="world-currency-wrapper">
      <div class="world-currency-inner">
        <div class="world-currency-item">
          <div class="symbol">USD<img :src="StaticImageUrl + 'assets/images/flag (2).png'"></div>
          <div class="value">{{ state_setting.usd_price }}</div>
        </div>
        <div class="world-currency-item">
          <div class="symbol">EUR<img :src="StaticImageUrl + 'assets/images/flag (1).png'"></div>
          <div class="value">{{ state_setting.eur_price }}</div>
        </div>
        <div class="world-currency-item">
          <div class="symbol">AED<img :src="StaticImageUrl + 'assets/images/flag (4).png'"></div>
          <div class="value">{{ state_setting.aed_price }}</div>
        </div>
        <div class="world-currency-item">
          <div class="symbol">TRY<img :src="StaticImageUrl + 'assets/images/flag (5).png'"></div>
          <div class="value">{{ state_setting.try_price }}</div>
        </div>
        <div class="world-currency-item">
          <div class="symbol">GBP<img :src="StaticImageUrl + 'assets/images/flag (3).png'"></div>
          <div class="value">{{ state_setting.gbp_price }}</div>
        </div>
      </div>
    </div>

    <div class="homain">
      <div class="row homain-inner">
        <div class="col-lg-6 col-sm-12">

          <div class="slogan">

            <h3 class="titr larger">بدون کارمزد</h3>
            <h3 class="titr">صراف خودت باش</h3>

            <router-link :to="{name:'FastBuy'}" class="ar-btn dark round" style="padding: 1.25rem 2.5rem;font-size:2.5rem;margin-top:2rem;flex-direction:column">
              <div>خرید فوری</div>
            </router-link>

            <router-link :to="{name:'Checkout'}" class="ar-btn dark round" style="padding: 1.75rem;font-size:1.85rem;margin-top:2rem;flex-direction:column">
              <div>تسویه الکترونیک</div>
            </router-link>
          </div>
          
        </div>
        <div class="col-lg-6 col-sm-12">

          <div class="realrate-panel-wrapper">
            <div v-if="state_prices" class="realrate-panel">
              <div class="titr">نرخ لحظه تتر</div>
              <div class="real-rate">
                <div class="real-rate-item buy">
                  <div class="name">خرید از ما</div>
                  <div class="value">{{ state_prices.sale_price }}</div>
                </div>
                <div class="real-rate-item sell">
                  <div class="name">فروش به ما</div>
                  <div class="value">{{ state_prices.buy_price }}</div>
                </div>
              </div>
              <div v-if="state_setting" class="real-rate">
                <div class="real-rate-item special">
                  <div class="name">
                    نرخ ویژه <i class="mdi mdi-information-outline"></i>
                  </div>
                  <div class="value">{{ state_setting.special_tether_rate }}</div>
                </div>
              </div>
            </div>
          </div>

          
          <div class="arms-wrapper">

            <div class="arm-wrapper">
              <img :src="StaticImageUrl + 'assets/images/samt.png'">
              <div class="title">پروانه فنی و مهندسی</div>
              <div class="code">120/2191397</div>
            </div>

            <div class="arm-wrapper">
              <img :src="StaticImageUrl + 'assets/images/samt.png'">
              <div class="title">پروانه تحقیق و توسعه</div>
              <div class="code">120/2191854</div>
            </div>

            <div class="arm-wrapper">
              <img :src="StaticImageUrl + 'assets/images/daraie.png'">
              <div class="title">کد اقتصادی</div>
              <div class="code">10380113428</div>
            </div>

            <div class="arm-wrapper">
              <img :src="StaticImageUrl + 'assets/images/ghazaieie.png'">
              <div class="title">شناسه ملی</div>
              <div class="code">10380113428</div>
            </div>

            <div class="arm-wrapper">
              <img :src="StaticImageUrl + 'assets/images/bazargani.png'">
              <div class="title">کارت بازرگانی</div>
              <div class="code">10380113428</div>
            </div>

            </div>

        </div>
      </div>
    </div>

    <Pulses></Pulses>
    <CryptoCurrencies></CryptoCurrencies>

    <div class="text-center">
      <router-link target="_blank" :to="{name:'RealTimePrice'}" class="ar-btn dark round size-md" style="border-radius: 0 0 20px 20px;">
        <div>مشاهده همه</div>
      </router-link>
    </div>

    <!-- <div class="clocks-wrapper">
      <div class="clocks-inner">

        <div class="clock-item">
          <div class="clock-main">
            <clock size="120px" :time="timezones.five"></clock>
          </div>
          <div class="clock-name">
            Tokyo
          </div>
        </div>

        <div class="clock-item">
          <div class="clock-main">
            <clock size="120px" :time="timezones.four"></clock>
          </div>
          <div class="clock-name">
            Shanghai
          </div>
        </div>

        <div class="clock-item">
          <div class="clock-main">
            <clock size="120px" :time="timezones.one"></clock>
          </div>
          <div class="clock-name">
            Tehran
          </div>
        </div>

        <div class="clock-item">
          <div class="clock-main">
            <clock size="120px" :time="timezones.three"></clock>
          </div>
          <div class="clock-name">
            London
          </div>
        </div>

        <div class="clock-item">
          <div class="clock-main">
            <clock size="120px" :time="timezones.two"></clock>
          </div>
          <div class="clock-name">
            New York
          </div>
        </div>

      </div>
    </div> -->
    <!-- <section class="section-hero section-hero-2 overlay-pattern mb-5 px-5 bg-back-drop" id="Home">

      <div class="real-rate-wrapper">
        <h4 class="mb-3">نرخ لحظه تتر:</h4>
          
        <div class="real-rate-inner">

          <div class="real-rate-item">
            <div class="in-item">
              <div v-if="state_prices" class="rate-box buy">{{ state_prices.sale_price }}</div>
              <div v-if="state_prices" class="rate-box sell">{{ state_prices.buy_price }}</div>
              <div v-if="state_prices" class="mx-2">تومان</div>
            </div>
            <div class="in-item">
              <div v-if="state_prices" class="rate-box buy">--</div>
              <div v-if="state_prices" class="rate-box sell">--</div>
              <div v-if="state_prices" class="mx-2">درهم</div>
            </div>
          </div>

          <div class="real-rate-item">
            <div class="in-item">
              <div v-if="state_prices" class="rate-box buy">--</div>
              <div v-if="state_prices" class="rate-box sell">--</div>
              <div v-if="state_prices" class="mx-2">دلار</div>
            </div>
            <div class="in-item">
              <div v-if="state_prices" class="rate-box buy">--</div>
              <div v-if="state_prices" class="rate-box sell">--</div>
              <div v-if="state_prices" class="mx-2">لیر</div>
            </div>
          </div>

          <div class="real-rate-item">
            <div class="in-item">
              <div v-if="state_prices" class="rate-box buy">--</div>
              <div v-if="state_prices" class="rate-box sell">--</div>
              <div v-if="state_prices" class="mx-2">یورو</div>
            </div>
            <div class="in-item">
              <div v-if="state_prices" class="rate-box buy">--</div>
              <div v-if="state_prices" class="rate-box sell">--</div>
              <div v-if="state_prices" class="mx-2">یوان</div>
            </div>
          </div> 

        </div>
      </div>

      <div class="nav-help">
        
        <ul class="justify-content-around">
          <li>
              <a @click="calc_modal = true">ماشین حساب</a>
          </li>
          <li>
              <a @click="arzine_club_modal = true">ارزینه کلاب</a>
          </li>
          <li>
              <a @click="trade_modal = true">معامله گری</a>
          </li>
          <li>
              <a @click="earning_modal = true">کسب درآمد</a>
          </li>
        </ul>
      </div>

      <div class="slider-wrapper">

        <hooper :wheelControl="false" :infiniteScroll="true" :autoPlay="true" :playSpeed="7000" :transition="1500">
          <slide>
            <img :src="StaticImageUrl+'assets/images/slideer-1.jpg'">
          </slide>
          <slide>
            <img :src="StaticImageUrl+'assets/images/slideer-5.png'">
          </slide>
          <hooper-navigation slot="hooper-addons"></hooper-navigation>
        </hooper>
      
      </div>

    </section> -->
       
    <!--  <template v-if="state_setting">
      <div v-if="parseFloat(state_setting.special_tether_rate)" class="special-rate-wrapper">
        <div class="special-rate-inner">
          <h4>نرخ ویژه
            <i class="fa fa-info-circle"></i>: 
          </h4>
          <div class="special-rate-box">{{ state_setting.special_tether_rate }}</div>
        </div>
      </div>
    </template> -->

    <div class="section-3 bg mt-4 mb-0 pb-0">

      <div class="section-3-box">
        <div class="row mx-0">
          <div class="col-md-4 col-sm-12">
            <div class="box-icon text-center">
              <img :src="StaticImageUrl+'assets/images/ease-icon.svg'">
            </div>
            <div class="box-title">
              <h3 class="text-center">سهولت</h3>
            </div>
            <div class="box-body">
              <p class="text-center px-5">
                به راحتی احراز هویت کنید و با چند کلیک خرید یا فروش خود را انجام دهید.
              </p>
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="box-icon text-center">
              <img :src="StaticImageUrl+'assets/images/fast-icon.svg'">
            </div>
            <div class="box-title">
              <h3 class="text-center">سرعت</h3>
            </div>
            <div class="box-body">
              <p class="text-center px-5">
                در هر ساعت از شبانه روز از سیستم پشتیبانی ارزینه استفاده کنید و در سریع ترین زمان ممکن ارز دیجیتال و یا ریال خود را دریافت کنید.
              </p>
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="box-icon text-center">
              <img :src="StaticImageUrl+'assets/images/confidence-icon.svg'">
            </div>
            <div class="box-title">
              <h3 class="text-center">اطمینان</h3>
            </div>
            <div class="box-body">
              <p class="text-center px-5">
                دارایی خود را در ارزینه تبادل کنید و امنیت دارایی تان را با کیف پول ها و حساب های ارزینه تضمین کنید.
              </p>
            </div>
          </div>
        </div>
      </div>

    </div>
     
    <div class="web-app-wrapper">

      <div class="row">
        <div class="col-lg-6 col-sm-12">
          <div class="web-app-poster">
            <img :src="StaticImageUrl+'assets/images/23885.png'" alt="">
          </div>
        </div>
        <div class="col-lg-6 col-sm-12">
          <div class="web-app-title">
            <h2 class="">ارزینه را همراه خود داشته باشید.</h2>
            <button class="ar-btn dark round web-app-install">نصب</button>
          </div>
        </div>
      </div>
      
    </div>
      
    <!-- <section class="section section-features section-features-1 section-about-us application" id="appDownload">
        <div class="container apps">
            <div class="row mx-0">
                <div class="col-md-6 wrapper">
                    <h2 class="ftitle">اپلیکیشن ارزینه</h2>
                    <p class="stitle">
                        خرید و فروش بیت کوین و سایر ارز های دیجیتال را به راحتی در گوشی خود داشته باشید و همیشه و همه جا معامله کنید.
                    </p>
                    <div class="app-icons-wrapper">
                        <a download href="assets/Arzine.apk"><img src="assets/images/direct_download.png"></a>
                        <a target="_blank" href="https://play.google.com/store/apps/details?id=com.sanbad.arzine"><img src="assets/images/googleplay-icon.png"></a>
                    </div>
                     <div class="app-icons-wrapper">
                        <img class="disabled" src="assets/images/appstore-icon.png">
                        <img class="disabled" src="assets/images/bazar-icon.png">
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="image-wrapper">
                        <img class="app-logo" src="assets/images/makeups.png">
                    </div>
                </div>
            </div>
        </div>
    </section>

    <Chatroom></Chatroom>      

    <LastArticles></LastArticles>
     -->

    <!-- <div class="statictics-wrapper">
      <div class="statictics-inner">
        <div class="statictics-item">
          <div class="statictics-title">
            حجم معاملات
          </div>
          <div class="statictics-value">
            --
          </div>
        </div>
        <div class="statictics-item">
          <div class="statictics-title">
            نمودار تتر
          </div>
          <div class="statictics-value">
            --
          </div>
        </div>
        <div class="statictics-item">
          <div class="statictics-title">
            تعداد کاربران
          </div>
          <div class="statictics-value">
            --
          </div>
        </div>
      </div>
    </div>

    <div class="crypto-wrapper">
        <div class="crypto-inner">
            <transition-group tag="div" name="slideup" class="ovhi">
                <div v-if="counter == 0" :key="0" class="inner">
                    <div v-for="(item , key) in crypto_list" :key="key" class="item">
                        <div class="d-flex align-items-center">
                          <img class="crypto-img" :src="'assets/images/icon/'+ item.imageName" alt="">
                          <h3 class="changes mb-1">{{item.prs}}</h3>
                        </div>
                        <div>
                          <p style="font-size:14px" class="changes mb-1">{{item.sale_price}} تومان</p>
                        </div>
                    </div>
                </div>
                <div v-if="counter == 1" :key="1" class="inner">
                    <div v-for="(item , key) in crypto_list" :key="key" class="item">
                      <div class="d-flex align-items-center">
                          <h3 class="changes mb-1">{{item.nikeName}}</h3>
                          <img class="crypto-img" :src="'assets/images/icon/'+ item.imageName" alt="">
                        </div>
                        <div>
                          <p style="font-size:14px" class="changes mb-1">${{parseFloat(item.lastPrice)}}</p>
                        </div>
                    </div>
                </div>
            </transition-group>
        </div>
    </div> -->

    <div class="section-7-wrapper">
      <div class="section-7-item">
        <h1>همین حالا شروع کنید!</h1>
        <div>به دنیای مالی دیجیتال ارزینه بپیوندید.</div>
      </div>
      <div class="section-7-item">
        <router-link :to="{name:'Register'}" class="ar-btn size-xl warning section-7-action">ثبت نام</router-link>
      </div>
    </div>

    <Footer></Footer>
    
    <Convertor v-if="calc_modal" @close="calc_modal = false"></Convertor>
    
    <Modal :open="fast_buy_modal" @close="fast_buy_modal = false">
      
      <div class="aboutus-wrapper">
          <div class="aboutus-inner p-4">
            <div class="d-flex justify-content-between">
              <h3>خرید فوری</h3>
              <h2><i @click="fast_buy_modal = false" class="fa fa-times"> </i></h2>
            </div>

            

            <div class="ar-form-group text-center">
              <label>مقدار خرید</label>
              <div style="max-width:200px;margin:auto">
              <input class="ar-form-control text-center"/>
              </div>
            </div>

            <div class="ar-form-group text-center">
              <label>مبلغ پرداختی</label>
              <div style="max-width:200px;margin:auto">
              <input class="ar-form-control text-center" disabled/>
              </div>
            </div>

            <div class="ar-form-group">
              <label>لطفا شماره تلفن همراه خود را وارد کنید</label>
              <input class="ar-form-control text-center" placeholder="9XXXXXXXXX" />
            </div>

            <div id="rule_accept" class="text-center text-light">
              <input type="checkbox" id="accept" >
              با <router-link :to="{name:'Rules'}" target="_blank" class="highlight">قوانین و مقررات </router-link>ارزینه
              <label class="accept" for="accept">
                موافقت می کنم
              </label>
            </div>
            

            <div class="ar-form-group">
              <label>آدرس ولت خود را وارد کنید</label>
              <input class="ar-form-control text-center" />
            </div>
            
            <div class="text-light">
              <div>کاربر گرامی, برای استفاده از این سرویس شما نیاز دارید که یک بار در سامانه وندار ثبت نام کنید.</div>
              <div></div>
            </div>
            
                        
              <div class="text-center">
                <button  class="ar-btn size-xl round primary disabled">پرداخت از طریق وندار</button>
              </div>

          </div>
      </div>
    </Modal>

  </div>
</template>
<script>
import Header from './Header'
import Footer from './Footer'
import CryptoCurrencies from '../components/CryptoCurrencies'
import Pulses from '../components/Pulses'
import Convertor from '../components/Convertor'
import LastArticles from '../components/LastArticles'
import Chatroom from '../components/Chatroom'
import Modal from '../components/Modal.vue'
import { Hooper, Slide , Navigation as HooperNavigation } from 'hooper';
import 'hooper/dist/hooper.css';
import Clock from 'vue-clock2';
export default {
  name: 'Home',
  components:{
    Clock,
    Modal,
    Header,
    Footer,
    CryptoCurrencies,
    Convertor,
    Pulses,
    LastArticles,
    Chatroom,
    Slide,
    HooperNavigation,
    Hooper
  },
  data : () => ({
    crypto_list : {},
    counter:0,
    SlideShowTimer:null,
    calc_modal:false,
    arzine_club_modal:false,
    trade_modal:false,
    earning_modal:false,
    fast_buy_modal:false,
    _timer:null,
    timezones:{
      one:null,
      two:null,
      three:null,
      four:null,
      five:null,
      six:null,
    }
  }),
  computed:{
  },
  methods: {
    getRealTimePrice (){
      return this.$axios.get(`getRealTimePrice?limit=6`)
      .then(res => {
        this.crypto_list = res.data.data
      })
      .catch(err => {
      });
    },
    changeSlideShow(){
      const vm = this
      vm.SlideShowTimer = setInterval(function() {
        if(vm.counter == 1){
          vm.counter = 0
        }else{
          vm.counter++
        }
      }, 12000);
    },
    showWorldClocks(){
      
      this.showTime();
      if (this._timer) clearInterval(this._timer);
      this._timer = setInterval(() => {
          this.showTime();
      }, 1000);

    },
    showTime(){
      this.timezones.one = new Date().toLocaleTimeString('en-US', { timeZone: 'Asia/Tehran' ,  hour12: false})
      this.timezones.two = new Date().toLocaleTimeString('en-US', { timeZone: 'America/New_York' ,  hour12: false})
      this.timezones.three = new Date().toLocaleTimeString('en-US', { timeZone: 'Europe/London' ,  hour12: false})
      this.timezones.four = new Date().toLocaleTimeString('en-US', { timeZone: 'Asia/Shanghai' ,  hour12: false})
      this.timezones.five = new Date().toLocaleTimeString('en-US', { timeZone: 'Asia/Tokyo' ,  hour12: false})
    }
  },
  created(){
    // this.getRealTimePrice()
    // this.changeSlideShow()
    // this.showWorldClocks()
  },
  mounted() {
    this.activeLoading(false)
  }
}
</script>
<style>
  .ovhi{
    overflow: hidden;
    height: 120px;
  }
  .changes{
    white-space: nowrap;
    overflow: hidden;
  }
  .apps{
    border: 2px solid var(--theme2);
    border-radius: 18px;
    padding: 50px 0;
  }
  .slideup-leave-active,
  .slideup-enter-active {
    transition: all 0.5s ease;
    overflow: hidden;
    /* position: relative; */
    box-sizing: border-box;
  }
  .slideup-enter-from,
  .slideup-leave-to {
    opacity: 0;
    transform: translateY(-100%);
  }
  .slideup-enter-to {
    opacity: 1;
    transform: translateY(0%);
  }
  .slideup-leave-from{
    opacity: 0;
    transform: translateY(100%);
  }

  
.arms-wrapper{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}
.arm-wrapper{
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
  color: #fff;
  width: 170px;
}
.arm-wrapper img{
  height: 80px;
}
.arm-wrapper .title{
  font-size: 12px;
}
</style>